// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //urlService: 'https://apiqa.buroidentidad.com:4010',
  //urlServiceCommon: 'https://apiqa.buroidentidad.com:9425', //QA BID
  urlService: 'https://api-dealerweb.buroidentidad.com:444', //PROD
  urlServiceCommon: 'https://api-tmv.buroidentidad.com:9425', //PROD
  
  //:DACTILAR -PROD
  urlIdentify : 'https://identy-lb1.buroidentidad.com:444',

  //FACIAL -PROD
  urlBalanceador: 'https://identy-lb1.buroidentidad.com',
  //authToken: 'bidtmv', //QA
  authToken: 'tmv',

  //speaker: 'tmvdwqa',
  speaker: 'tmvdwprod',
  skipFingerValidationAgent: true,
  ratioFace: .40,
  //version: '1.2.7.6.2' 
  version: '1.3.1' //Prod
}; 


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
